// extracted by mini-css-extract-plugin
export default {"listLink":"ListLink_listLink__xA+qK"};